<template>
	<div
		class="
			grid
			rem:auto-rows-[378px]
			xs:grid-cols-2
			md:grid-cols-3
			lg:grid-cols-4
			gap-3.5
			sm:gap-8

			*:rounded-2.5xl
			*:shadow-md
			*:skeleton-gradient
			md:[&:nth-child(n+7)]:*:hidden
			lg:[&:nth-child(n+7)]:*:block
		"
	>
		<div v-for="index in 8" :key="index" />
	</div>
</template>
